module.exports = __webpack_public_path__ + "static/media/ariel.c392be15.png";